import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import over from "../assets/over.jpg";
import "./styles/win.css";
import Over from "./over";
import Stat from "./StatistiquesMobile.jsx";

import { Trophy, Shield, Globe, Skull, TreePine, Flame, Users, Target, Zap } from 'lucide-react';


import HistoryVerdict from './HistoryVerdict';

const GameOver = ({ gameState }) => {
    const navigate = useNavigate();
    const nbAnnees = gameState.year ? gameState.year - 2030 : 0;
    const [showVerdict, setShowVerdict] = useState(false);

    useEffect(() => {
    }, [gameState]);

    const FloatingParticles = ({ color = 'blue' }) => {
        const colorMap = {
            blue: 'bg-blue-400',
            green: 'bg-green-400',
            red: 'bg-red-400',
            orange: 'bg-orange-400'
        };

        return (
            <div className="absolute overflow-hidden">
                {[...Array(20)].map((_, i) => (
                    <div
                        key={i}
                        className={`absolute w-1 h-1 ${colorMap[color]} rounded-full animate-ping`}
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                            animationDelay: `${Math.random() * 3}s`,
                            animationDuration: `${2 + Math.random() * 3}s`
                        }}
                    />
                ))}
            </div>
        );
    };

    if (showVerdict) {
        return <HistoryVerdict gameState={gameState} />;
    }

    return (
        <div className="relative w-full bg-black">
            {/* Contenu principal */}
            <div className="relative h-screen bg-gradient-to-br from-slate-900 via-red-900 to-slate-800 overflow-hidden">
                <FloatingParticles color="red" />

                <div className="absolute inset-0 overflow-hidden">
                    {[...Array(6)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute opacity-20  animate-spin"
                            style={{
                                left: `${20 + i * 15}%`,
                                top: `${30 + (i % 3) * 20}%`,
                                animationDelay: `${i * 0.5}s`
                            }}
                        >
                            <Skull className="text-red-500 animate-pulse w-16 h-16" />
                        </div>
                    ))}
                </div>

                <div className="relative z-10 text-center p-8 bg-black/40 backdrop-blur-sm rounded-3xl border border-red-500/30 max-w-2xl mx-4"
                    style={{ margin: '0 auto', marginTop: '20px', marginBottom: '20px' }}>

                    <div className="mb-8">
                        <Skull className="w-24 h-24 text-red-500 mx-auto mb-4 animate-bounce"
                            style={{ filter: 'drop-shadow(0 0 20px rgba(239, 68, 68, 0.6))' }} />
                        <Shield className="w-16 h-16 text-red-600 mx-auto animate-pulse opacity-50" />
                    </div>

                    <h1 className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-400 mb-4 animate-pulse">
                        ÉLIMINATION MILITAIRE
                    </h1>

                    <p className="text-xl text-red-200 mb-8 leading-relaxed">
                        Vos forces ont été anéanties par des adversaires plus rusés.
                        L'IA ennemie a surpassé vos stratégies militaires.
                    </p>

                    <div className="grid grid-cols-3 gap-6 text-center">
                        <div className="bg-red-900/50 p-4 rounded-xl">
                            <div className="text-3xl font-bold text-red-300">{gameState.joueur?.population ?? 0}</div>
                            <div className="text-red-200 text-sm">Population Perdus</div>
                        </div>
                        <div className="bg-red-900/50 p-4 rounded-xl">
                            <div className="text-3xl font-bold text-orange-300">
                                +{gameState.climate?.degree ?? 1.5}°C
                            </div>
                            <div className="text-red-200 text-sm">Degrées</div>
                        </div>
                        <div className="bg-red-900/50 p-4 rounded-xl">
                            <div className="text-3xl font-bold text-red-400">{nbAnnees}</div>
                            <div className="text-red-200 text-sm">Années Survécus</div>
                        </div>
                    </div>
                </div>
                <div className="relative z-10 mt-8 mb-12 flex flex-col gap-4 items-center">
                    <button
                        onClick={() => setShowVerdict(true)}
                        className="px-8 py-4 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-xl font-bold text-white shadow-lg hover:scale-105 transition-transform flex items-center gap-3"
                    >
                        <Trophy className="w-6 h-6" />
                        Voir le Jugement de l'Histoire
                    </button>
                    <button
                        onClick={() => navigate('/review')}
                        className="px-8 py-4 bg-gradient-to-r from-red-600 to-orange-500 rounded-xl font-bold text-white shadow-lg hover:scale-105 transition-transform flex items-center gap-3"
                    >
                        <Globe className="w-6 h-6" />
                        Revoir la carte et les journaux
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GameOver;
